import React from "react";
import LandingPage from "../components/Home/LandingPage";
import Footer from "../components/Home/Footer";

const Home = () => {
  return (
    <div>
      <LandingPage />
      <Footer />
    </div>
  );
};

export default Home;
